import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-rt-rabbitmq-code',
	templateUrl:'./RabbitMQCodeSamplesPage.html',
	styles: [],
	styleUrls:['./RabbitMQCodeSamplesPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
],
	standalone:true
})
export class RabbitMQCodeSamplesPage
{
	mdContent_1174 = `\`\`\`java
@Inject
private RabbitPublishToGroup publisher;

publisher.publish("dashboard-updates", jsonPayload);
publisher.publish("user-" + userId, notification);
\`\`\``;
	mdContent_1175 = `\`\`\`java
var dashboard = new DivSimple<>();
dashboard.addAttribute("[data-rabbit-groups]", "'live-feed'");
add(dashboard);
\`\`\``;
	mdContent_1176 = `\`\`\`xml
<!-- pom.xml -->
<dependency>
    <groupId>com.jwebmp</groupId>
    <artifactId>jwebmp-rabbitmq</artifactId>
</dependency>

# Environment
RABBITMQ_HOST=localhost
RABBITMQ_PORT=5672
RABBITMQ_WEB_STOMP_PORT=15674

// module-info.java
requires com.jwebmp.rabbit;
requires com.guicedee.rabbit;
\`\`\``;
}
